import { requireNativeViewManager } from 'expo-modules-core';
import * as React from 'react';

import { NekoTestViewProps } from './NekoTest.types';

const NativeView: React.ComponentType<NekoTestViewProps> =
  requireNativeViewManager('NekoTest');

export default function NekoTestView(props: NekoTestViewProps) {
  return <NativeView name={props.name} />;
}
